import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">
              <Link to="/" className="cursor-pointer hover:text-primary-300 transition-colors">韩漫大全</Link>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫大全提供海量好看韩国漫画免费在线阅读。资源丰富、更新及时、分类清晰，是您看韩漫的最佳漫画网址。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/hot" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">热门连载</Link></li>
              <li><Link to="/category/new" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">最新上架</Link></li>
              <li><Link to="/category/completed" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">完结漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/romance" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">动作漫画</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">悬疑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><span className="text-sm text-background-400">联系邮箱：contact@hanmandq.com</span></li>
              <li><span className="text-sm text-background-400">每日 00:00 更新</span></li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">© 2026 韩漫大全 - 好看韩国漫画免费在线阅读平台. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer" aria-label="RSS" rel="nofollow">
              <i className="ri-rss-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}